"use client";

import { useEffect } from "react";
import Script from "next/script";

export default function KoalendarWidget() {
  useEffect(() => {
    const handleGlobalClick = (e) => {
      const target = e.target.closest('a, button');
      if (!target) return;

      const href = target.getAttribute('href');
      const text = target.textContent || '';
      
      const isDiagnosticButton = 
        href && 
        (href.startsWith('/contact') || href.startsWith('#contact') || href === '#booking') && 
        (text.toLowerCase().includes('diagnostic') || 
         text.toLowerCase().includes('réservation') || 
         text.toLowerCase().includes('reservation') || 
         target.hasAttribute('data-koalendar'));

      if (isDiagnosticButton) {
        e.preventDefault();
        if (window.Koalendar) {
          window.Koalendar('open', {
            url: 'https://koalendar.com/e/rencontrer-contact-bizyoo'
          });
        } else {
          window.location.href = href;
        }
      }
    };

    document.addEventListener('click', handleGlobalClick);
    return () => {
      document.removeEventListener('click', handleGlobalClick);
    };
  }, []);

  return (
    <>
      <Script id="koalendar-stub" strategy="lazyOnload">
        {`window.Koalendar = window.Koalendar || function () { (Koalendar.props = Koalendar.props || []).push(arguments) };`}
      </Script>
      <Script
        src="https://koalendar.com/assets/widget.js"
        strategy="lazyOnload"
        onLoad={() => {
          window.Koalendar && window.Koalendar("init");
        }}
      />
    </>
  );
}